<template>
      <b-form-group id="input-Login" :label="label" label-for="Login">
            <!-- Alteração: adição do autocomplete -->
            <b-form-input
              id="Login"
              :value="value"
              @input="getValue"
              type="text"
              placeholder="CPF ou E-mail"
              :state="state"
              @change="$emit('change', value)" 
              class="no-border"
              required
            ></b-form-input>
            
            <b-form-invalid-feedback :state="state">
                  <div class="login_invalid">
                        {{validationMessage}}
                  </div>
            </b-form-invalid-feedback>
            
          </b-form-group>
</template>

<script>
export default {
      name : "InputLogin",
      props : {
            value : String,
            validationMessage : String,
            label : String
      },
      methods: {
            getValue(value)
            {
                  this.$emit('input', value)
            }
      },
      computed: {
            state() {
                  if (this.validationMessage == null)
                        return null

                  return !this.validationMessage
            }
      }
}
</script>
